import {useRef} from 'react';

import {useOnMount} from 'shared/web';

import {TEST_DRIVE_CALENDAR} from '../constants/TEST_DRIVE_CALENDAR';

export const useDelayedTooltipClose = (onClose: () => void) => {
  const closeTimeoutRef = useRef<ReturnType<typeof setTimeout>>(undefined);

  const cancel = () => clearTimeout(closeTimeoutRef.current);

  useOnMount(undefined, cancel);

  const schedule = () => {
    cancel();
    closeTimeoutRef.current = setTimeout(onClose, TEST_DRIVE_CALENDAR.TOOLTIP_CLOSE_DELAY_MS);
  };

  return {cancel, schedule};
};
